import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu'
import * as StyledDropdownComponents from './styles'

export { DropdownContent } from './DropdownContent'
export const DropdownMenuItem = StyledDropdownComponents.StyledDropdownMenuItem
export const DropdownSeparator = StyledDropdownComponents.StyledSeparator
export const DropdownMenu = DropdownMenuPrimitive.Root
export const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger
export const DropdownIconTrigger = StyledDropdownComponents.StyledIconButton
